

exports.__esModule = true;
exports.formatNameInformal = formatNameInformal;

var _locale = require('../locale');

// Mapping of Griffin fields to name fields that should be used
var SUBSTITUTED_FIELDS = {
    givenName: 'first_name',
    surname: 'last_name'
};

// Griffin fields that should use the Griffin provided value in key "_"
var UNSUBSTITUTED_FIELDS = {
    // Separator value can be '' or ' ', so allow value to be inserted into string
    separator: true
};

/**
 * Formats name into informal format based on Griffin metadata
 * @param  {Object} name The name to be formatted, containing first_name and last_name properties
 * @return {String}      The formatted string, or null if data is missing
 */
function formatNameInformal(name) {
    var layout = _locale.$locale.metadata.nameInformal && _locale.$locale.metadata.nameInformal.layout;
    if (!layout) {
        return name.first_name || null; // Default to first name if metadata not loaded
    }

    // Map griffin layout parts to the name passed in. If it requires a value not passed in name, returns null early
    var formattedName = [];
    for (var i = 0; i < layout.length; i++) {
        var namePart = layout[i];
        if (SUBSTITUTED_FIELDS[namePart.$]) {
            var mappedField = SUBSTITUTED_FIELDS[namePart.$];
            if (mappedField === undefined) {
                return null;
            }

            formattedName.push(name[mappedField]);
        } else if (UNSUBSTITUTED_FIELDS[namePart.$]) {
            formattedName.push(namePart._);
        }
    }

    return formattedName.join('');
}

_locale.$locale;


/*****************
 ** WEBPACK FOOTER
 ** ./components/squid/dist/locale/name.js
 ** module id = 135
 ** module chunks = 1
 **/